import React from 'react';
import { ArrowRight, CheckCircle2, MessageCircle } from 'lucide-react';

export const Hero = () => {
  return (
    <section id="hero" className="relative h-[85vh] flex items-center justify-center overflow-hidden mt-20">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://customer-assets.emergentagent.com/job_smart-snacks/artifacts/3w9iy2el_ChatGPT%20Image%2010%20mar%202026%2C%2008_31_14%20p.m..png"
          alt="BOCADIA Vending Machine - La pausa que tu día merece"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#003847]/95 via-[#003847]/75 via-[#003847]/50 to-transparent"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 w-full -mt-16">
        <div className="max-w-4xl">
          {/* Main Heading */}
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 leading-tight">
            Más comodidad para{' '}
            <span className="text-[#CFAE70]">tus espacios, sin inversión</span>
          </h1>

          {/* Subtitle */}
          <p className="text-lg md:text-xl text-white/95 mb-8">
            Instalamos máquinas inteligentes de café, snacks y bebidas
          </p>

          {/* Benefits List - Better spacing */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4 mb-10 max-w-2xl">
            {[
              'Instalación gratuita',
              'Operación 100% gestionada',
              'Pagos digitales (Yape, Plin, tarjeta)',
              'Servicio disponible 24/7'
            ].map((benefit, index) => (
              <div
                key={index}
                className="flex items-start gap-3 text-white/95 text-sm md:text-base py-1"
              >
                <CheckCircle2 className="w-5 h-5 md:w-5 md:h-5 text-[#CFAE70] flex-shrink-0 mt-0.5" />
                <span className="leading-relaxed">{benefit}</span>
              </div>
            ))}
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="https://api.whatsapp.com/send/?phone=51992098884&text=Hola+me+interesa+instalar+una+maquina+en+uno+de+mis+espacios&type=phone_number&app_absent=0"
              target="_blank"
              rel="noopener noreferrer"
              className="group inline-flex items-center justify-center gap-3 px-8 py-3.5 bg-[#CFAE70] text-white font-bold text-base rounded-lg hover:bg-[#B89A5F] transition-all duration-300 hover:scale-105 hover:shadow-2xl shadow-xl"
            >
              <MessageCircle className="w-5 h-5" />
              Solicitar instalación
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </a>
            
            <a
              href="https://api.whatsapp.com/send/?phone=51937468463&text=Buen+dia,+necesito+ayuda+con+un+incidente+en+la+maquina+ubicada+en+&type=phone_number&app_absent=0"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-3 px-8 py-3.5 bg-white/10 backdrop-blur-sm text-white font-semibold text-base rounded-lg hover:bg-white/20 transition-all duration-300 border border-white/30"
            >
              <MessageCircle className="w-5 h-5" />
              Escribir a soporte
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
